import CreateRole from "../../features/dashboard/roles/CreateRole";

function CreateRolesDB() {
    return <CreateRole />
}

export default CreateRolesDB